<template>
    <div class="w-100">
        <div class="map-item-filter">
            <div
                class="col-sm-12 nopads vehicle-list"
                :class="{ list_closed: !listOpen }"
            >
                <span
                    class="vehicle-list-title"
                    @click.stop="toggleList"
                >
                    {{ $t('menu.observations') }} ({{ observations ? observations.length : 0 }})
                </span>
                <div
                    class="vehicle-list-caret"
                    :class="{ caret_open: listOpen }"
                    @click.stop="toggleList"
                >
                    <font-awesome-icon icon="caret-down" />
                </div>
                <div
                    v-if="listOpen"
                    class="col-sm-12 nopads vehicle-list-container"
                    style="overflow-x: hidden"
                >
                    <!-- Observation status filters -->
                    <div
                        v-if="selectedContractIds && selectedContractIds.length > 0"
                        class="badge-filters__wrapper"
                    >
                        <div class="badge-filters px-2">
                            <span
                                v-for="(item, index) in statusFilters"
                                :key="index"
                                :class="['badge', 'ml-2', isActiveStatusFilter(item.value) ? 'bg-primary text-light' : 'bg-light text-dark', 'py-1', 'px-2']"
                                style="cursor: pointer"
                                @click="toggleStatusFilter(item.value)"
                            >
                                {{ item.text }}
                            </span>
                        </div>
                    </div>
                    <!-- Created time filters -->
                    <hr
                        class="nopads px-2 mb-2"
                        style="border-color: #6e914c"
                    >
                    <div class="badge-filters__wrapper">
                        <div class="badge-filters px-2 pt-2">
                            <span
                                v-for="(item, index) in timeFilters"
                                :key="index"
                                :class="['badge', 'ml-2', isActiveTimeFilter(item.value) ? 'bg-primary text-light' : 'bg-light text-dark', 'py-1', 'px-2']"
                                style="cursor: pointer"
                                @click="toggleTimeFilter(item.value)"
                            >
                                {{ item.text }}
                            </span>
                        </div>
                    </div>
                    <!-- Slider -->
                    <div v-if="selectedTimeFilter === 1"  class="col-12 px-2">
                        <div class="row nopads">
                            <div class="col-sm-8">
                            </div>
                            <div class="col-sm-4 d-flex justify-content-end">
                                <span class="vehicle-list-no-results nopads text-end">{{ days + ' ' + 'd' }}</span>
                            </div>
                        </div>
                        <input
                            id="range"
                            v-model="days"
                            type="range"
                            class="form-range mb-2"
                            :min="minDays"
                            :max="maxDays"
                            @change="fetchObservations"
                        >
                    </div>

                    <!-- User input -->
                    <div v-if="selectedTimeFilter === 2">
                        <div v-if="selectedTimeFilter === 2" class="d-flex flex-row mb-2">
                            <div class="col-sm-6 px-2">
                                <span class="date-picker-label text-light">
                                  {{ $t('map_filters.create_date_from') }}
                                </span>
                                <date-time-picker
                                    v-model:date="createDateFrom"
                                    class="routa-input"
                                    format="dd.MM.yyyy"
                                    :enable-time-picker="false"
                                    :clearable="true"
                                />
                            </div>
                            <div class="col-sm-6 px-2">
                                <span class="date-picker-label text-light">
                                  {{ $t('map_filters.create_date_to') }}
                                </span>
                                <date-time-picker
                                    v-model:date="createDateTo"
                                    class="routa-input"
                                    format="dd.MM.yyyy"
                                    :enable-time-picker="false"
                                    :clearable="true"
                                />
                            </div>
                        </div>
                        <div class="button-container pb-2 px-2">
                            <button
                                size="md"
                                class="btn btn-sm btn-success"
                                :disabled="!createDateFrom || !createDateTo"
                                @click.stop="fetchObservations"
                            >
                                <span class="map-button-text">{{ $t('ins_report.search') }}</span>
                            </button>
                        </div>
                    </div>

                    <!-- User reported -->
                    <hr
                        class="nopads px-2 mb-2"
                        style="border-color: #6e914c"
                    >
                    <div class="d-flex flex-row mb-2 px-2">
                        <div class="col-12">
                            <div class="form-check d-flex align-items-center">
                                <input
                                    id="assigner"
                                    v-model="reportedByUser"
                                    type="checkbox"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label px-2 pt-1"
                                    style="color: #ffffff; font-size: .9em"
                                    for="assigner"
                                >
                                    {{ $t('observations.reported_by_user') }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Observation type filters -->
                    <hr
                        class="nopads px-2 mb-2"
                        style="border-color: #6e914c"
                    >
                    <div
                        class="map-select-item"
                    >
                        <div class="form-check">
                            <input
                                id="checkboxAllObservations"
                                :checked="allSelected"
                                :indeterminate.prop="indeterminate"
                                type="checkbox"
                                class="form-check-input"
                                @change="onToggleAllChange"
                            />
                            <label
                                class="form-check-label text-light"
                                for="checkboxAllObservations"
                                style="font-size: .9em"
                            >
                                {{ allSelected ? $t('observations.deselect_all') : $t('observations.select_all') }}
                            </label>
                        </div>
                    </div>
                    <div
                        class="map-select-item"
                    >
                        <!-- Check box for select/ unselect types -->
                        <span
                            class="text-light"
                            style="font-size: .9em; font-weight: bold"
                        >{{ $t('observations.type_select_hint') }}</span>
                        <div class="col-12 p-1">
                            <div class="row nopads">
                                <div
                                    v-for="(option, index) in typeEntries"
                                    :key="index"
                                    class="col-6 nopads"
                                >
                                    <div class="form-check">
                                        <input
                                            id="checkbox-{{ option.value }}"
                                            v-model="selectedTypes"
                                            type="checkbox"
                                            :value="option.value"
                                            :disabled="loading"
                                            class="form-check-input form-check-input-sm"
                                        >
                                        <label
                                            :for="'checkbox-' + option.value"
                                            class="form-check-label text-light"
                                            style="font-size: .9rem;"
                                        >
                                            {{ option.text }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <observation-editor
            v-if="editMode"
            :observation="observation"
            :is-observer="isObserver"
            :user="user"
            @close="hideObservationEditor"
            @close-and-update="closeAndUpdate"
        />

        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from '../mixins/MapMixin'
import ObservationEditor from './ObservationEditor'
import DateTimePicker from "@/components/common/DateTimePicker";
import {restApi} from '../mixins/RestApiMixin'
import  {geometryMixin} from "@/components/mixins/GeometryMixin";
import {promisify} from "../../modules/promise";

const STATUS = {
    ALL: 0,
    OPEN: 1,
    CLOSED: 2,
}

const INIT_STATUS = STATUS.OPEN

import obsSvg from '@/assets/observation.svg'
import obsClosedSvg from '@/assets/observation_closed.svg'

export const obsHistoryModes = {
    ALL: null,
    SLIDER: 1,
    USER_INPUT: 2
}

export default {
    name: 'ObservationMap',
    components: {DateTimePicker, ObservationEditor},
    mixins: [timeUtils, mapHelper, restApi, geometryMixin],
    props: {
        observationResults: {
            type: Array,
            default() {
                return null
            }
        },
        observationItem: {
            type: Object,
            default: null
        },
        map: {
            type: Object,
            default: null
        },
        infoVisible: {
            type: Boolean,
            default: true
        },
        zoomOnDrawMarker: {
            type: Boolean,
            default: false
        },
        draggable: {
            type: Boolean,
            default: false
        },
        zoomToObservations: {
            type: Boolean,
            default: false
        },
        selectedContractIds: {
            type: Array,
            default() {
                return []
            }
        },
        selectedOrder: {
            type: Number,
            default: null
        },
        boundingBox: {
            type: Array,
            default: null
        },
        requireBoundingBox: {
            type: Boolean,
            default: false
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: null
        },
        filters: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            mounted: false,
            loading: false,
            editMode: false,
            days: 7,
            minDays: 1,
            maxDays: 30,
            createDateFrom: null,
            createDateTo: null,
            reportedByUser: false,
            observations: [],
            visibleObservations: [],
            typeEntries: [],
            selectedTypes: [],
            observation: null,
            listOpen: false,
            allSelected: false,
            indeterminate: false,
            visibilityZoomLevel: 7,
            TYPE: {
                POINT: 1,
                POLY_LINE: 2
            },
            Z_INDEX: {
                BEHIND: 2,
                INFRONT: 5
            },
            selectedStatusFilter: INIT_STATUS,
            selectedTimeFilter: obsHistoryModes.ALL,
            timeFilters: [
                {text: this.$t('common.all'), value: obsHistoryModes.ALL},
                {text: "1-30 d", value: obsHistoryModes.SLIDER},
                {text: this.$t('common.time_range'), value: obsHistoryModes.USER_INPUT},
            ],
            statusFilters: [
                {
                    text: this.$t("common.all"),
                    value: STATUS.ALL,
                },
                {
                    text: this.$t("common.open"),
                    value: STATUS.OPEN,
                },
                {
                    text: this.$t("common.closed"),
                    value: STATUS.CLOSED,
                },
            ],
        }
    },

    computed: {
        observationGeometry() {
            return this.observation?.geometry
        }
    },

    watch: {
        map() {
            this.$nextTick(function () {
                if (this.observationResults && this.observationResults.length > 0) {
                    this.initView()
                } else if (this.isBBoxValid(this.boundingBox)) {
                    this.fetchObservations(true)
                }
            })
        },
        selectedTypes(newVal) {
            if (newVal.length === 0) {
                this.indeterminate = false
                this.allSelected = false
            } else if (newVal.length === this.typeEntries.length) {
                this.indeterminate = false
                this.allSelected = true
            } else {
                this.indeterminate = true
                this.allSelected = false
            }
            this.filterByTypes()
            this.emitFilterOptions()
        },
        selectedStatusFilter(newVal) {
            if (newVal.length > 1 && this.isActiveStatusFilter(STATUS.ALL)) {
                this.selectedStatusFilter = newVal.filter((activeFilter) => activeFilter !== STATUS.ALL);
            }
            if (newVal.length === 0) {
                this.selectedStatusFilter = INIT_STATUS;
            }
            this.fetchObservations(true)
            this.emitFilterOptions()
        },
        selectedTimeFilter() {
            this.fetchObservations(true)
            this.emitFilterOptions()
        },
        boundingBox() {
            if (!this.observationResults && this.map && this.isBBoxValid(this.boundingBox)) {
                this.fetchObservations()
            }
        },
        selectedContractIds() {
            if (!this.observationResults && this.map) {
                this.fetchObservations(true)
            }
        },
        selectedOrder() {
            if (!this.observationResults && this.map) {
                this.fetchObservations(true)
            }
        },
        observationGeometry() {
            if (this.observation && (!this.observations && this.observations.length < 1)) {
                this.drawObservation(this.observation)
            }
        },
        reportedByUser() {
            this.fetchObservations(true)
            this.emitFilterOptions()
        }
    },

    mounted: function () {
        // Set filters
        if (this.filters) {
            // Set status
            this.selectedTypes = this.filters.types
            this.selectedTimeFilter = this.filters.history
            this.days = this.filters.sliderValue
            this.createDateFrom = this.filters.createdFrom
            this.createDateTo = this.filters.createdTo
            this.selectedStatusFilter = this.selectedContractIds && this.selectedContractIds.length > 0 ? this.filters.status : STATUS.OPEN
            this.reportedByUser = this.filters.reportedByUser
        }
        this.mounted = true
        if (this.observationItem) {
            this.observation = this.observationItem
        } else if (this.observationResults && this.observationResults.length > 0) {
            this.observations = this.observationResults
            this.initView()
        } else if (this.map && (!this.requireBoundingBox || this.isBBoxValid(this.boundingBox))) {
            this.fetchObservations()
        }
    },
    beforeUnmount() {
        this.hideObservations()
    },

    methods: {

        fetchObservations(force) {
            if (!this.map || !this.mounted) {
                return
            }
            if (this.map.getMapZoomLevel() < this.visibilityZoomLevel) {
                this.bbox = null
                this.hideObservations()
            } else if (force || (!this.requireBoundingBox || (this.boundingBox && (!this.bbox || this.isBboxOutsideBbox(this.boundingBox, this.bbox))))) {
                this.loading = true
                let params = {}
                if (this.requireBoundingBox && this.boundingBox) {
                    const extendRate = 0.005
                    this.bbox = [
                        this.boundingBox[0] - extendRate,
                        this.boundingBox[1] - extendRate,
                        this.boundingBox[2] + extendRate,
                        this.boundingBox[3] + extendRate
                    ]
                    params.bbox = this.bbox
                }
                if(this.selectedContractIds && this.selectedContractIds.length > 0) {
                    params.contract = this.selectedContractIds
                    if(this.selectedOrder) {
                        params.order = this.selectedOrder
                    }
                } else {
                    // Reset time filter so only open ones will be fetched without a contract
                    this.selectedStatusFilter = 1
                }
                if(this.selectedStatusFilter !== null) {
                    params.status = this.selectedStatusFilter !== 0 ? this.selectedStatusFilter : null
                } else {
                    // if selectedStatusFilter is undefined we don't want to fetch all observations initially
                    params.status = 1
                }
                // Time range
                if (this.selectedTimeFilter === obsHistoryModes.SLIDER) {
                    const today = new Date()
                    const fromTime = new Date(today.getTime() - this.days * 24 * 60 * 60 * 1000)
                    params.from = fromTime.toISOString()
                } else if (this.selectedTimeFilter === obsHistoryModes.USER_INPUT) {
                    params.from = this.createDateFrom
                    params.to = this.createDateTo
                }
                // Reported
                if (this.reportedByUser) {
                    params.reporter = this.user.id
                }
                this.restFetchParams(this.observationMapUrl, params, this.handleObservationResponse, this.handleObservationsError)
            }
        },

        handleObservationResponse: function (response) {
            this.loading = false
            this.hideObservations()
            this.observations = []
            if (response && response.data) {
                this.observations.push(...response.data)
            }
            let params = {}
            if (this.selectedStatusFilter !== null && this.selectedStatusFilter !== 0) {
                params.status = this.selectedStatusFilter
            }
            this.initView()
            if (this.allSelected && this.observations.length > 0) {
                this.selectedTypes = this.typeEntries.map(entry => entry.value)
            }
        },

        handleObservationsError: function () {
            this.loading = false
            this.initView()
        },

        async initView() {
            if (this.observations || this.observation) {
                this.hideObservations()
            }
            if (this.observations && this.observations.length > 0) {
                this.visibleObservations = this.observations
                this.initTypeEntries()
                this.filterByTypes()
            } else if (this.observation) {
                this.drawObservation(this.observation, this.infoVisible)
            }
            if (this.map && this.observations && this.zoomToObservations) {
                await this.$nextTick()
                this.map.zoomToGroup(this.OBSERVATION)
            }
        },

        drawObservations: function () {
            this.visibleObservations.forEach(function (observation) {
                this.drawObservation(observation, false)
            }, this)
        },

        drawObservation: function (observation) {
            var pointToZoom = null
            let markerStore = this.map.getMarkerStore()
            if (observation.geometry.point) {
                const icon = observation.closed_time ?
                    markerStore.getSvgMarker(obsClosedSvg, null, null, '2em', '2em') :
                    markerStore.getSvgMarker(obsSvg, null, null, '2em', '2em')
                this.map.showMapMarker(observation.id, this.OBSERVATION, observation.geometry.point.y,
                    observation.geometry.point.x, icon, this.draggable, observation.closed_time ? this.Z_INDEX.BEHIND : this.Z_INDEX.INFRONT)
                pointToZoom = observation.geometry.point
            } else if (observation.geometry.line_string) {
                var closed = !!observation.closed_time
                var color = closed ? '#bcbcbc' : observation.public === true ? '#faba1b' : '#bb330e'
                var points = observation.geometry.line_string.points.map(point => {
                    return {x: point[0], y: point[1]}
                })
                this.map.drawPolyLine(observation.id, this.OBSERVATION, points, color, false, false, 5, 1, true, closed)
                pointToZoom = points[0]
            }
            if (pointToZoom && this.zoomOnDrawMarker) {
                this.map.zoomToPosition(pointToZoom.y, pointToZoom.x)
            }
        },

        hideObservations: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.OBSERVATION)
            }
            this.visibleObservations = []
            this.showDetails = false
        },

        async onMarkerTap(data) {
            if (data.type !== this.OBSERVATION) {
                return;
            }
            if (this.observation && data.id === this.observation.id && this.editMode) {
                this.editMode = false;
                return;
            }
            this.loading = true;
            const response = await promisify(this.restFetch)(this.observationDetailsUrl + '/' + data.id)
                .catch(this.handleError)
                .finally(() => this.loading = false);
            if (!response || !response.data) {
                return;
            }
            this.editObservation(response.data)
        },

        handleError: function () {
            // TODO - Indicate error somehow
        },

        showObservationTitle: function (data) {
            // Show info bubble
            if (data.type === this.OBSERVATION) {
                let item = this.observations.find(o => o.id === data.id)
                if (item) {
                    let x, y
                    if (item.geometry && item.geometry.point) {
                        x = item.geometry.point.x
                        y = item.geometry.point.y
                    }
                    if (item.geometry && item.geometry.line_string) {
                        x = item.geometry.line_string.points[0][0]
                        y = item.geometry.line_string.points[0][1]
                    }
                    if (item) {
                        this.map.addMarkerLabel(item.id, item.name, y, x, data.type)
                    }
                }
            }
        },

        hideObservationTitle: function (data) {
            // Hide info bubble
            this.map.hideMarkerLabel(data.id, data.type)
        },

        hideObservationEditor: function () {
            this.editMode = false
        },

        editObservation: function (observation) {
            this.observation = observation
            if (this.observation) {
                this.editMode = true
            }
        },

        closeAndUpdate: function () {
            this.editMode = false
            this.fetchObservations(true)
        },

        initTypeEntries: function () {
            this.typeEntries = []
            if (this.observations && this.observations.length > 0) {
                this.observations.forEach(item => {
                    let existingType = this.typeEntries.find(element => element.value === item.type_id)
                    if (!existingType) {
                        this.typeEntries.push({text: item.name, value: item.type_id})
                    }
                })
                this.sortTypeEntries()
            }
        },

        sortTypeEntries: function () {
            this.typeEntries.sort(function (a, b) {
                if (a.text < b.text) {
                    return -1;
                }
                if (a.text > b.text) {
                    return 1;
                }
                return 0;
            });
        },

        filterByTypes: function () {
            this.hideObservations()
            this.visibleObservations = []
            if (this.allSelected) {
                this.visibleObservations = this.observations
            } else {
                this.observations.forEach(item => {
                    let selectedType = this.selectedTypes.find(element => element === item.type_id)
                    if (selectedType) {
                        this.visibleObservations.push(item)
                    }
                })
            }
            this.$emit('visibleObservationsChanged', this.visibleObservations)
            this.drawObservations()
        },

        toggleList: function () {
            this.listOpen = !this.listOpen
        },

        toggleAll() {
            this.selectedTypes = []
            if (this.allSelected) {
                this.typeEntries.forEach(item => {
                    this.selectedTypes.push(item.value)
                })
            }
        },
        onToggleAllChange(event) {
            if (event.target.checked) {
                this.selectedTypes = this.typeEntries.map(entry => entry.value)
            } else {
                this.selectedTypes = []
            }
            this.emitFilterOptions()
        },
        toggleStatusFilter(val) {
            this.selectedStatusFilter = val
        },
        isActiveStatusFilter(val) {
            return val === this.selectedStatusFilter
        },
        toggleTimeFilter(val) {
            this.selectedTimeFilter = val
        },
        isActiveTimeFilter(val) {
            return val === this.selectedTimeFilter
        },
        getVisibleObservations() {
            return this.visibleObservations
        },
        emitFilterOptions() {
            let filters = {
                "history": this.selectedTimeFilter,
                "sliderValue": this.days,
                "createdFrom": this.createDateFrom,
                "createdTo": this.createDateTo,
                "status": this.selectedStatusFilter,
                "types": this.selectedTypes,
                "reportedByUser": this.reportedByUser
            }
            this.$emit('filtersUpdated', filters)
        }
    }
}
</script>

<style lang="scss" scoped>
.badge-filters {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    flex: 5;
    flex-wrap: wrap;

    & > * {
        cursor: pointer;
    }

    &__wrapper {
        display: flex;
        align-items: flex-start;
    }
}
</style>
